<template>
  <div class="modal fade close-generate-token-modal" id="ConfirmDeleteConfigurationSftpModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar configuração SFTP ?</h1>
                  <button type="button" class="btn-close close-generate-token-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeleteConfigurationSftp" v-on:submit="deleteConfigurationSftpMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Quer realmente deletar a configuração SFTP ?</p>
                  <p>se precisar desta configuração no futuro, será necessário criar novamente</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="remote_path" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_account_delete"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiDeleteSftp" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeleteSftp">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonDeleteConfigurationUpdateSftp" class="btn btn-dark">Deletar</button>
                  <button type="button" class="btn btn-danger close-generate-token-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "ConfirmDeleteConfigurationSftpModal",
  data () {
    return {
      loadingAudioPlayer: false,
      errorMessage: ""
    }
  },
  computed:{
    ...mapGetters([
        'getCurrentRecording',
        'getCurrentUrlRecording',
        'getRecordingShowModalState',
        'getCurrentConfigurationSftp'
    ])
  },
  methods: {
    ...mapActions([
      "setNewToken"
    ]),
    deleteConfigurationSftpMethod(){
      event.preventDefault();

      if(
        document.getElementById("password_account_delete") == undefined ||
        document.getElementById("password_account_delete").value == ""
      ){
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }
      
      if(this.getCurrentConfigurationSftp == null){
        this.alertResponse("Erro por favor tente novamente mais tarde", true);
        return;
      }

      const password_account_delete = document.getElementById("password_account_delete").value;
      const id_delete = this.getCurrentConfigurationSftp.id;

      const configurationSftp = {
        "id": id_delete,
        "password": password_account_delete
      }

      const buttonDeleteConfigurationUpdateSftp = this.$refs.buttonDeleteConfigurationUpdateSftp;
      buttonDeleteConfigurationUpdateSftp.disabled = true;
      buttonDeleteConfigurationUpdateSftp.innerHTML = "Deletando...";
      const alertResponse = this.alertResponse;

        api.axios.post('/api/delete/configurations/sftp', configurationSftp).catch(function(error){
          if(error.response.data != undefined){
            buttonDeleteConfigurationUpdateSftp.innerHTML = "Deletar";
          }
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonDeleteConfigurationUpdateSftp.innerHTML = "Configuração deletada com sucesso !";
            window.location.reload();
          } else {
            buttonDeleteConfigurationUpdateSftp.disabled = false;
            buttonDeleteConfigurationUpdateSftp.innerHTML = "Deletar";
            alertResponse("Erro por favor tente novamente mais tarde", true);
            document.getElementById("password_account_delete").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageDeleteSftp").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeleteSftp").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeleteSftp");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password_account_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>